import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme'; // Import tema kustom Anda

import LoginPage from './pages/LoginPage';
import MWCDashboard from './pages/MWCDashboard';
import LazisnuDashboard from './pages/LazisnuDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import useAuthStore from './store/useAuthStore';

import RantingDashboard from './pages/RantingDashboard';
import UserManagementPage from './pages/UserManagementPage';

import GlobalPerformanceDashboard from './pages/GlobalPerformanceDashboard';
import RantingMonitoringPage from './pages/RantingMonitoringPage';
import AggregatedReportPage from './pages/AggregatedReportPage';
import UnitManagementPage from './pages/UnitManagementPage';
import LazisnuTransactionPage from './pages/LazisnuTransactionPage';
import MWCTransactionPage from './pages/MWCTransactionPage';
import RantingTransactionPage from './pages/RantingTransactionPage';
import RantingReportPage from './pages/RantingReportPage';

function App() {
  const checkAuth = useAuthStore((state) => state.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/mwc-dashboard"
            element={
              <ProtectedRoute allowedRoles={['MWC']}>
                <MWCDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mwc/transactions"
            element={
              <ProtectedRoute allowedRoles={['MWC']}>
                <MWCTransactionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mwc/monitor-ranting"
            element={
              <ProtectedRoute allowedRoles={['MWC']} denyLapangan={true}>
                <RantingMonitoringPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mwc/aggregated-report"
            element={
              <ProtectedRoute allowedRoles={['MWC']} denyLapangan={true}>
                <AggregatedReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ranting-dashboard"
            element={
              <ProtectedRoute allowedRoles={['RANTING']}>
                <RantingDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ranting/report"
            element={
              <ProtectedRoute allowedRoles={['RANTING']}>
                <RantingReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ranting/transactions/add"
            element={
              <ProtectedRoute allowedRoles={['RANTING']}>
                <RantingTransactionPage />
              </ProtectedRoute>
            }
          />
          <Route path="/lazisnu-dashboard" element={
              <ProtectedRoute allowedRoles={['LAZISNU']}>
                <LazisnuDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute allowedRoles={['LAZISNU']} denyLapangan={true}>
                <UserManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/units"
            element={
              <ProtectedRoute allowedRoles={['LAZISNU']} denyLapangan={true}>
                <UnitManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/global-performance"
            element={
              <ProtectedRoute allowedRoles={['LAZISNU']} denyLapangan={true}>
                <GlobalPerformanceDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/transactions"
            element={
              <ProtectedRoute allowedRoles={['LAZISNU']}>
                <LazisnuTransactionPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
